var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpPolygon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 81,
    viewBox: "0 0 84 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7902 46.3167C40.3896 44.1658 43.6104 44.1658 45.2099 46.3167L66.2508 74.6132C68.2132 77.2522 66.3296 81 63.041 81H20.959C17.6704 81 15.7868 77.2522 17.7492 74.6132L38.7902 46.3167Z",
    fill: "#EAEBF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6918 2.19953L80.4105 27.4241C82.6118 29.0235 83.5329 31.8585 82.6921 34.4463L69.4307 75.2606C68.5899 77.8484 66.1784 79.6005 63.4573 79.6005H20.5427C17.8216 79.6005 15.4101 77.8484 14.5693 75.2606L1.3079 34.4463C0.467064 31.8585 1.38819 29.0235 3.58953 27.4241L38.3082 2.19952C40.5096 0.600158 43.4904 0.600159 45.6918 2.19953Z",
    stroke: "#2D389F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpPolygon2);
export default __webpack_public_path__ + "static/media/helpPolygon2.19072cec13ee96d6b4f0d82a41687a3c.svg";
export { ForwardRef as ReactComponent };